// extracted by mini-css-extract-plugin
export default {"recoverPg":"styles_recoverPg__kfdvE","formRecover":"styles_formRecover__YMMJX","separador":"styles_separador__uHSWO"};